"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrostshieldAbilityHandler = exports.FrostshieldActorAbilityFactory = exports.FrostshieldAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const enums_1 = require("../../core/enums");
class FrostshieldAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Frostshield;
        this.__typeName = "Frostshield";
    }
}
exports.FrostshieldAbilityArgs = FrostshieldAbilityArgs;
let FrostshieldActorAbilityFactory = class FrostshieldActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Frostshield", "AllAllies", 4);
    }
};
FrostshieldActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Frostshield")
], FrostshieldActorAbilityFactory);
exports.FrostshieldActorAbilityFactory = FrostshieldActorAbilityFactory;
let FrostshieldAbilityHandler = class FrostshieldAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            animatedId: ability.invokerId,
            fallback: "casting",
            onAnimated(sequence) {
                container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                    .forEach(targetId => {
                    container.applyBuffs({
                        sequence: sequence,
                        creatorId: ability.invokerId,
                        targetId,
                        effects: [
                            {
                                duration: Duration_1.Duration.Turns(4),
                                effect: new core_1.LinkedEffectsEffectArgs([
                                    new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.AllDamageImmunity, 10),
                                    new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.PhysicalDamageImmunity, 10)
                                ], false),
                                onApplied: sequence => {
                                    sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "chest"), "SwirlingIceShield"));
                                }
                            }
                        ]
                    });
                });
            },
        });
    }
};
FrostshieldAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Frostshield)
], FrostshieldAbilityHandler);
exports.FrostshieldAbilityHandler = FrostshieldAbilityHandler;
